import * as React from 'react'

import { TQOrderForForm } from '~graphql/generated/clientGraphql'
import { createContext } from '~logic/lib/react'

type TFormOrder = Nullable<TQOrderForForm['order']>

const [Provider, useFormOrderCtx] = createContext<TFormOrder>(`FormOrder`)

type TProps = RequiredChildren & {
  order: TFormOrder
}

/**
 * Context provider for order-related data required by the FormScreen.
 * Use the `useFormOrder` to access the order.
 */
export const FormOrderProvider: React.FC<TProps> = ({ children, order }) => {
  return <Provider value={order}>{children}</Provider>
}

export { useFormOrderCtx }
